/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import ContactContent from 'gatsby-rage-ppc-theme/src/components/atoms/contact-content/index';

export default (props) => {
  return <ContactContent {...props} email={"support@watchfooty.co.uk"} />;
};
